<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="searchCriterias"></ng-container>
        </tt-card>

        <tt-list-legacy [listItems]="itemsListViews" ltype="multi" [designVar]="'s12t0'" typevar="g"></tt-list-legacy>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="requisitionplanview_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card>
                        <ng-container *ngTemplateOutlet="searchCriterias"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="70">
                    <tt-list-legacy [listItems]="itemsListViews" ltype="multi" [designVar]="'s12t0'" typevar="g"></tt-list-legacy>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #searchCriterias>
    <ng-container *ngIf="!!setting">
        <tt-select ttRememberId="w_requisitionplanview.stockplace_id_from" ttLabel="stockplace_from" [(ttModel)]="setting.stockplace_id_from" (ttModelChange)="onChanged($event, 'stockplace_id_from')" [ttData]="selectListStockPlacesFrom" ttDataId="stockplace_id" ttDataName="stockplace_name"></tt-select>
        <tt-select ttRememberId="w_requisitionplanview.stockplace_id_to" ttLabel="stockplace_to" [(ttModel)]="setting.stockplace_id_to" (ttModelChange)="onChanged($event, 'stockplace_id_to')" [ttData]="selectListStockPlacesTo" ttDataId="stockplace_id" ttDataName="stockplace_name"></tt-select>

        <form class="form-horizontal sp-0" name="formRequisitionPlanViewSearch" novalidate (ngSubmit)="searchItems()" method="get" role="form">
            <tt-input ttRememberId="w_requisitionplanview.productsearch_searchtext" ttLabel="productsearch_searchtext" ttFocus="false" [(ttModel)]="setting.productsearch_searchtext" (ttModelChange)="onChanged($event, 'productsearch_searchtext')" ttShowClearButton [ttButtons]="productSearchButtons"></tt-input>
        </form>
    </ng-container>
</ng-template>
